import {Component, OnInit} from '@angular/core';
import {OnDestroyMixin, untilComponentDestroyed} from '@w11k/ngx-componentdestroyed';
import {Observable} from 'rxjs';
import {ICardToSend, State as dashState} from '@app/4dm1n/tango-cards/_store/tango-card.reducers';
import {select, Store} from '@ngrx/store';
import {selectAdminTangoState} from '@app/4dm1n/tango-cards/_store/tango-cards.selectors';
import {distinctUntilChanged} from 'rxjs/operators';
import {AppState} from '@store/app.states';
import {AbstractControl, Form, UntypedFormArray, UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {addCardsToSend, sendCards, sendCardSetState} from '@app/4dm1n/tango-cards/_store/tango-cards.actions';

interface ACard {
  brand: string;
  name: string;
  currency: string;
  imageUrl: string;
  utid: string;
  faceValue: string;
  amountChoosed: number;
}

@Component({
    selector: 'app-send-cards',
    templateUrl: './send-cards.component.html',
    styleUrls: ['./send-cards.component.scss'],
    standalone: false
})
export class SendCardsComponent extends OnDestroyMixin implements OnInit {

  importMode = false;

  fEmailsToImport: UntypedFormControl = new UntypedFormControl();

  fEmailToCard: UntypedFormGroup = new UntypedFormGroup({
      cardTypeChoosed: new UntypedFormControl(null, [Validators.required]),
      amountChoosed: new UntypedFormControl(null, [Validators.required, this.moreThan0()]),
      mailGroup: new UntypedFormGroup({
        // from: new FormControl('info@inbe.ca', [Validators.required]),
        subject: new UntypedFormControl('Votre carte cadeau', [Validators.required]),
        message: new UntypedFormControl('', [Validators.required]),
      }),
      recipients: new UntypedFormArray([]),
    }
  );

  frecipients: UntypedFormArray = this.fEmailToCard.controls.recipients as UntypedFormArray;

  cardChoosed: ACard = null;

  formState = null;

  cardList: ACard[] = [];

  sendToPayload: ICardToSend[] = [];


  // selectAdminTangoState
  dashboardDatas$: Observable<dashState> = this.store.pipe(
    select(selectAdminTangoState),
    distinctUntilChanged(),
    untilComponentDestroyed(this),
  );

  constructor(
    private store: Store<AppState>,
    private toastr: ToastrService,
  ) {
    super();
  }

  moreThan0(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (control.value) {
        return (+control.value <= 0) ? {moreThan0Validation: {value: control.value}} : null;
      }
      return null;
    };
  }

  ngOnInit(): void {

    this.dashboardDatas$.pipe(untilComponentDestroyed(this)).subscribe((datas) => {
      this.cardList = [];
      if (datas?.data?.cardCatalog?.brands?.length > 0) {
        datas.data.cardCatalog.brands.forEach((aBrand) => {
          aBrand.items.forEach((item) => {
            this.cardList.push({

              utid: item.utid,
              brand: aBrand.brandName,

              name: item.rewardName,

              currency: item.currencyCode,
              imageUrl: aBrand.imageUrls['130w-326ppi'],
              faceValue: item.faceValue || 'none',
              amountChoosed: item.faceValue || '',

            });
          });
        });
      }
    });

    //
    //
    //
    this.addAReceipt();
    //
    //
    this.fEmailToCard.valueChanges.pipe(untilComponentDestroyed(this)).subscribe(() => {

      //
      // Changement de carte
      //
      this.cardChoosed = this.cardList.find((aCard) => aCard.utid === this.fEmailToCard.controls.cardTypeChoosed.value);

      if (this.cardChoosed?.faceValue !== 'none') {
        this.fEmailToCard.controls.amountChoosed.disable({emitEvent: false});
        this.fEmailToCard.controls.amountChoosed.patchValue(+this.cardChoosed?.faceValue, {emitEvent: false});
      } else {
        this.fEmailToCard.controls.amountChoosed.enable({emitEvent: false});
      }

      this.cardChoosed.amountChoosed = +this.fEmailToCard.controls.amountChoosed.value;

      if (+this.fEmailToCard.controls.amountChoosed.value === 0) {
        this.fEmailToCard.controls.amountChoosed.setErrors({moreThan0Validation: {value: 0}});
        this.cardChoosed.amountChoosed = null;
      }

      this.fEmailToCard.controls.amountChoosed.markAsTouched();

      this.frecipients.controls.forEach((aGroup: UntypedFormGroup) => {
        if (aGroup.controls.amount.pristine) {
          aGroup.controls.amount.patchValue(+this.fEmailToCard.controls.amountChoosed.value, {emitEvent: false});
        }
      });

      this.formState = this.fEmailToCard.getRawValue();

    });

  }

  removeReceipt(index) {

    this.frecipients.removeAt(index);

  }

  addAReceipt() {
    this.frecipients.push(
      new UntypedFormGroup({
        email: new UntypedFormControl('', [Validators.required, Validators.email]),
        amount: new UntypedFormControl(this.fEmailToCard.controls.amountChoosed.value, [Validators.required, this.moreThan0()]),
      })
    );
  }

  validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl) {
        control.markAsTouched({onlySelf: true});
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  convertToEmails() {

    if (this.fEmailsToImport.value) {

      const toImport =
        this.fEmailsToImport.value
          .trim()
          .split(' ')
          .join(',')
          .split(/\r?\n/)
          .join(',')
          .split(';')
          .join(',')
          .split(',')
          .map((el) => el.replace(/'/g, ''))
        || [];

      this.frecipients.clear();

      toImport.forEach((aEmail) => {
        this.frecipients.push(
          new UntypedFormGroup({
            email: new UntypedFormControl(aEmail, [Validators.required, Validators.email]),
            amount: new UntypedFormControl(this.fEmailToCard.controls.amountChoosed.value, [Validators.required, this.moreThan0()]),
          })
        );
      });

    }

    this.importMode = false;

  }

  reviewCards() {

    //
    // 1. On vérifie qu'on a un email et un montant > 0 pour tous
    //
    this.frecipients.controls.forEach((aGroup: UntypedFormGroup) => {
      aGroup.controls.email.markAsTouched({onlySelf: true});
      aGroup.controls.amount.markAsTouched({onlySelf: true});
      if (aGroup.controls.amount.value === 0) {
        aGroup.controls.amount.setErrors({moreThan0Validation: {value: 0}});
      }
    });

    //
    // 2. On vérifie que tout est ok côté validators:
    //
    this.validateAllFormFields(this.fEmailToCard);

    if (!this.fEmailToCard.valid) {
      this.toastr.error('Check form elements...', '[Invalid form!]', {
        timeOut: 7000,
        progressBar: true,
        enableHtml: true,
      });
    } else {

      this.sendToPayload = [];
      this.formState.recipients.forEach((aReceipt) => {

        this.sendToPayload.push({
          utid: this.cardChoosed.utid,
          amount: aReceipt.amount,
          email: aReceipt.email,

          subject: this.formState.mailGroup.subject,
          message: this.formState.mailGroup.message,

          isSending: false,
          done: false,
          error: false,
          result: {},

        });

      });

      this.store.dispatch(addCardsToSend({cards: this.sendToPayload}));

      if (this.sendToPayload.length === 1) {
        this.doSendCards();
      }

    }

  }

  doSendCards(): void {

    this.store.dispatch(sendCards());
    this.frecipients.clear();
    this.addAReceipt();

  }
  setState(state: 'edit' | 'review' | 'send') {
    this.store.dispatch(sendCardSetState({state}));
  }

}
